import { DatasetTemplateDocument } from '@app/types/dataSet';
import { MASTER_CODE_TYPE } from './master_code_consts';

export enum DESIGN_CHANGE_DATA {
  create = '追加',
  update = '更新',
  noChange = '無変更',
}
export const STRUCTURE_LABEL = [
  {
    code: '001',
    label: '建築',
    value: 'Architecture',
    publicationListKey: 'arcPublication',
  },
  {
    code: '002',
    label: '構造',
    value: 'Structure',
    publicationListKey: 'strPublication',
  },
  {
    code: '003',
    label: '設備',
    value: 'Equipment',
    publicationListKey: 'mepPublication',
  },
];
export const DIVISION_OPTIONS = [
  { label: '--', value: null },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
];

export const ROWS_PER_PAGE_OPTIONS_JA = [
  { label: '20件', value: 20 },
  { label: '50件', value: 50 },
  { label: '100件', value: 100 },
];

export const ROWS_PER_PAGE_OPTIONS_EN = [
  { label: '20 items', value: 20 },
  { label: '50 items', value: 50 },
  { label: '100 items', value: 100 },
];
export enum STRUCTURE_CODE_ENUM {
  ARC = '001',
  STR = '002',
  MEP = '003',
}

export enum STRUCTURE_LABEL_ENUM {
  ARC = '建築',
  STR = '構造',
  MEP = '設備',
}

export enum PRICING_EST_LABEL_ENUM {
  EST_ARC = '見積（建築）',
  EST_STR = '見積（構造）',
  EST_MEP = '見積（設備）',
}

export enum QSTAK_QS_LABEL_ENUM {
  TAK_QS_ARC = 'TAK-QS（仕上）',
  TAK_QS_STR = 'TAK-QS（構造）',
  TAK_QS_MEP = 'TAK-QS（設備）',
}

export enum STRUCTURE_VALUE_ENUM {
  ARC = 'Architecture',
  STR = 'Structure',
  MEP = 'Equipment',
}

export enum SHARED_STATUS_ENUM {
  notSharing = '001',
  sharingComplete = '002',
  sharingError = '003',
  sharing = '004',
}

export enum PUBLICATION_STATUS_CODE_ENUM {
  complete = '001',
  error = '002',
  notSharing = '003',
  sharing = '004',
}

export const SC007_CONST = {
  DOCUMENT_IMPORT_STEP: '2',
  INITIAL_PURPOSE_ID: '001',
  INITIAL_PHASE_ID: '002',
  ITEM_CODE_STRUCTURAL_ESTIMATE: '003',
  // Mapping between profession role IDs and profession codes used in SC007.
  PROFESSION_ROLE_TO_PROFESSION_CODE: {
    '001': '001',
    '002': '002',
    '003': '003',
  } as const,
  PHASE_LABEL_JA: '基本設計(2PH)',
  PHASE_LABEL_EN: 'Basic Design (2PH)',
  /** Characters not allowed in a document file name: \ / : * ? " < > */
  INVALID_FILENAME_CHARS: /[\\/:*?"<>]/,
  /** Fields subject to inline validation in the document-edit form. */
  DOCUMENT_EDIT_VALIDATED_FIELDS: ['documentName', 'purposeId', 'itemCode'] as const,
  /** Field key for the item code property on SC007ImportDocumentItem. */
  ITEM_CODE_FIELD: 'itemCode' as const,
  URL_BOX_FILE_ID: (boxFileId: string) => `https://app.box.com/file/${boxFileId}` as const,
  CONTAINER_ID: 'sc007-box-picker-container' as const,
  IFRAME_ID: 'sc007-box-picker-container-iframe' as const,
  CONFIRMED: '確定' as const,
  INTERNAL: '社内' as const,
  BOX_TYPE_FOLDER: 'folder' as const,
  BOX_TYPE_FILE: 'file' as const,
} as const;

export const SC006_CONST = {
  INITIAL_PURPOSE_ID: '001',
  INITIAL_PHASE_ID: '002',
  PHASE_LABEL_JA: '基本設計(2PH)',
  PHASE_LABEL_EN: 'Basic Design (2PH)',
} as const;

export const SC010_CONST = {
  QUANTITY_SURVEY_TITLE: '数量積算',
  PRICING_TITLE: '値入',
  REQUEST_TYPE_TITLE: '精概算',
} as const;

export const FIELD_CONST = {
  SORT_BY_CREATED_AT: 'createdAt' as const,
  SORT_BY_UPDATED_AT: 'updatedAt' as const,
  SORT_BY_EMPLOYEE_NUMBER: 'employeeNumber' as const,
} as const;

export const ITEM_CODE_TYPES = [
  MASTER_CODE_TYPE.ITEM_TYPE_1,
  MASTER_CODE_TYPE.ITEM_TYPE_2,
  MASTER_CODE_TYPE.ITEM_TYPE_3,
] as const;

export enum ELEMENT_RESULT_OF_AUTOMATION_CHECK_ENUM {
  PASS = 'PASS',
  FAIL = 'FAIL',
}

export const MAX_LENGTH = 255;

export enum ELEMENT_STATUS_OF_AUTOMATION_CHECK_ENUM {
  Information = 'I',
  Warning = 'W',
  Fatal = 'F',
}

export enum ELEMENT_MODEL_ENUM {
  ARC = 'ARCHITECT_MODEL',
  STR = 'STRUCTURE_MODEL',
  MEP = 'EQUIPMENT_MODEL',
}

export enum TEXT_ELEMENT_ENUM {
  WarningEn = 'Warning',
  WarningJa = 'ワーニング',
  FatalEn = 'Fatal',
  FatalJa = 'フェータル',
}

export const ELEMENT_STATUS = {
  PASS: 'P',
  INFO: 'I',
  WARN: 'W',
  FATAL: 'F',
} as const;

export const INITIAL_CONST = {
  PROJECT_ROLE_ID: '001',
  DEFAULT_PROFESSION_CODE: '000',
  USER_GUIDE_NUMBER: '2',
  INITIAL_AUTO_CHECK_FLG: '001',
  INITIAL_PURPOSE_ID: '001',
  INITIAL_PROFESSION_CODE: '001',
  INITIAL_PHASE_ID: '002',
} as const;

export enum USER_CHECK_STATUS_ENUM {
  CONFIRMED = 'CONFIRMED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export enum AUTOCHECK_STATUS_ENUM {
  PASS = 'PASS',
  FAIL = 'FAIL',
  NOT_USED = 'autocheckNotUsed',
}

export const EMPTY_DOCUMENT_LIST: DatasetTemplateDocument[] = [
  {
    files: [],
    role: { value: 'ARC', label: STRUCTURE_LABEL_ENUM.ARC },
  },
  {
    files: [],
    role: { value: 'STR', label: STRUCTURE_LABEL_ENUM.STR },
  },
  {
    files: [],
    role: { value: 'MEP', label: STRUCTURE_LABEL_ENUM.MEP },
  },
];

export const AUTOCHECK_TYPE = {
  WITH: 'with',
  TEXT_WITH: '自動チェック付き共有',
  TEXT_WITH_EN: 'Share With Automation Check',
  SKIP: 'skip',
  TEXT_SKIP: '自動チェックをスキップして共有',
  TEXT_SKIP_EN: 'Share Without Automation Check',
} as const;

export const INPUT_TYPE = {
  text: 'text',
  email: 'email',
  search: 'search',
} as const;

export const BM0006_STATUS = {
  notSharing: '001',
  sharingError: '003',
  sharingComplete: '002',
  sharing: '004',
} as const;

export const BM0051_STATUS = {
  availabel: '001',
  needsChange: '002',
  inProgress: '003',
} as const;
